<template>
  <div class="user-profile container">
    <div class="user-profile__wrapper">
      <div class="user-profile__header">
        <div class="user-profile__image">
          <form>
            <AppImage v-if="user.avatar" @click="uploadFile" :src="userImage" alt="user-avatar" />
            <UserShortName v-else @click.native="uploadFile" :shortName="shortName" />
            <input
              id="fileid"
              type="file"
              hidden
              @change="fileUploaded"
              accept="image/png, image/jpeg"
            />
          </form>
        </div>
        <div class="user-profile__basic-info">
          <AppHeading tag="h1">{{ userFullName }}</AppHeading>
          <AppHeading v-if="user.account" tag="span">{{ user.account.name }}</AppHeading>
        </div>
      </div>
      <div class="user-profile__info">
        <AppTabs currentTab="general">
          <!-- account -->
          <AppTabsTab slot="general" key="normal" title="General">
            <AppForm :callback="submit">
              <!-- username -->
              <AppInput label="Usuario" v-model="user.username" prepend-icon="fa fa-user" />
              <!-- email -->
              <AppInput
                v-model="user.email"
                prepend-icon="fa fa-envelope"
                label="Email"
                type="email"
              />
            </AppForm>
          </AppTabsTab>
          <!-- settings -->
          <AppTabsTab slot="ajustes" title="Ajustes" key="12">
            <AppForm :callback="submit">
              <AppSwitch v-model="user.email_notifications" label="Notificaciones por email" />

              <AppSwitch v-model="user.is_active" label="Active" />

              <AppSwitch v-model="user.remember" label="Editor" />
            </AppForm>
          </AppTabsTab>
        </AppTabs>
      </div>
    </div>
  </div>
</template>

<script>
// Utilities
import { mapGetters } from 'vuex'
import config from 'Services/config'
// Components
import AppTabs from 'Ui/AppTabs'
import AppInput from 'Ui/AppInput'
import AppTabsTab from 'Ui/AppTabsTab'
import AppImage from 'Ui/AppImage'
import AppForm from 'Components/AppForm'
import AppHeading from 'Ui/AppHeading'
import UserShortName from 'Components/UserShortName'
import AppSwitch from 'Ui/AppSwitch'

export default {
  name: 'UserProfile',

  components: {
    AppForm,
    AppTabs,
    AppImage,
    AppInput,
    AppTabsTab,
    AppHeading,
    UserShortName,
    AppSwitch,
  },
  data() {
    return {
      user: null,
    }
  },
  methods: {
    uploadFile(event) {
      event.target.nextElementSibling.click()
    },

    fileUploaded(event) {
      // const form = event.target.parentElement
      const imageFile = event.target.files[0]

      let form_data = new FormData()
      form_data.append('image', imageFile, imageFile.name)
      // console.log(form_data.get('image'))
      this.$store.dispatch('user/updateUserInfo', { avatar: form_data.get('image') })
    },

    submit() {
      // console.log(this.user)
    },
  },
  computed: {
    ...mapGetters({
      shortName: 'user/shortName',
    }),
    userFullName() {
      return `${this.user.first_name} ${this.user.last_name}`
    },
    userImage() {
      return `${config.baseURL}${this.user.avatar}`
    },
    eyeIcon() {
      return this.passVisible ? 'fal fa-eye' : 'fal fa-eye-slash'
    },
  },
  beforeMount() {
    this.user = this.$store.state.user.currentUser
  },
}
</script>

<style scoped>
.user-profile__header {
  display: flex;
}

.user-profile__header .app-image {
  border-radius: 50%;
  cursor: pointer;
}

.user__short-name {
  font-size: 24px;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  cursor: pointer;
  user-select: none;
}

.user-profile__basic-info {
  margin-left: 40px;
}

.user-profile__info {
  margin-top: 60px;
  overflow: hidden;
}

.app-form .app-input-field {
  margin-bottom: 20px;
}

.app-form >>> .app-input {
  font-size: 16px;
}
</style>
